import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'jquery.cookie';

let mediaCentre = {};

(function (mediaCentreApp) {
	let filterModel = {
		Month: 0,
		Year: 0,
		SearchTerm: "",
		Tags: null,
		Page: 1
	};
	const cookieName = "_oa_mediaCentreSearchParams";
	const mcLandingDocTypeAlias = "mediaCentreLanding";
	const pageType = $("#media-search-form").data("type");

	let fromPopState = false;
	let blockPopstateEvent = true;
	const browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			const currentPath = window.location.pathname;
			let query = "?";
			let queryArray = [];
			if (filterModel.Month) {
				queryArray.push("month=" + filterModel.Month);
			}
			if (filterModel.Year) {
				queryArray.push("year=" + filterModel.Year);
			}
			if (filterModel.SearchTerm) {
				queryArray.push("search=" + filterModel.SearchTerm);
			}
			if (filterModel.Tags) {
				queryArray.push("tags=" + filterModel.Tags);
			}
			if (filterModel.Page) {
				queryArray.push("page=" + filterModel.Page);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.Month = 0;
		filterModel.Year = 0;
		filterModel.SearchTerm = "";
		filterModel.Tags = null;
		filterModel.Page = 1;
		mediaCentreApp.setInputValue();

		if (window.location.search.length > 1) {
			for (let aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				const key = decodeURIComponent(aItKey[0]).toLowerCase();
				const val = decodeURIComponent(aItKey[1]);

				if (key === "month") {
					filterModel.Month = val;
				} else if (key === "year") {
					filterModel.Year = val;
				} else if (key === "search") {
					filterModel.SearchTerm = val;
				} else if (key === "tags") {
					filterModel.Tags = val;
				} else if (key === "page") {
					filterModel.Page = val;
				}
				mediaCentreApp.setInputValue();
			}
		}
		mediaCentreApp.GetSearchResults();
	}

	mediaCentreApp.setInputValue = function () {
		$("#month").val(filterModel.Month);
		$("#year").val(filterModel.Year);
		$("#searchArg").val(filterModel.SearchTerm);
		$("#searchArgMobile").val(filterModel.SearchTerm);
		$("#tags").val(filterModel.Tags);
		
		if (filterModel.Tags !== null && filterModel.Tags !== "" && typeof filterModel.Tags !== 'undefined') {
			$("#advanced-search").click();

			//Tags sometimes gets stored as an array of strings rather then a comma separated string.
			if (Array.isArray(filterModel.Tags)) {
				filterModel.Tags = filterModel.Tags.join();
			}
			let choicesToSet = filterModel.Tags.split(',');
			window.choices.setChoiceByValue(choicesToSet);
		}
	};

	mediaCentreApp.GetSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/MediaCentreSurface/GetSearchResults",
			type: "POST",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-media-results").html(data);
				pushHistory();

				$([document.documentElement, document.body]).animate({
					scrollTop: $(".js-media-results").offset().top - $("header").outerHeight()
				}, 200);
			}
		});
	};

	$(document).ready(function () {
		//prevent fancybox triggering performSearchFromUrl() after window close
		$.fancybox.defaults.hash = false;

		//check if querystring params exist on load/reload
		const urlParams = new URLSearchParams(window.location.search);
		const hasUrlParams = urlParams.has('month') || urlParams.has('year') || urlParams.has('search') || urlParams.has('tags') || urlParams.has('page');

		if (hasUrlParams) {
			if (urlParams.get('month')) {
				filterModel.Month = urlParams.get('month');
			}

			if (urlParams.get('year')) {
				filterModel.Year = urlParams.get('year');
			}

			if (urlParams.get('search')) {
				filterModel.SearchTerm = urlParams.get('search');
			}

			if (urlParams.get('tags')) {
				filterModel.Tags = urlParams.get('tags');
			}

			if (urlParams.get('page')) {
				filterModel.Page = urlParams.get('page');
			}

			mediaCentreApp.setInputValue();

			setCookie();
		}
		else
		{
			if (pageType === mcLandingDocTypeAlias) {
				removeCookie();
			}

			// get params saved in cookie 
			let cookieValue = null;
			if (typeof $.cookie(cookieName) !== 'undefined') {
				cookieValue = JSON.parse($.cookie(cookieName));
			}

			if (cookieValue) {
				if (cookieValue.Month) {
					filterModel.Month = parseInt(cookieValue.Month);
				}
				if (cookieValue.Year) {
					filterModel.Year = parseInt(cookieValue.Year);
				}
				if (cookieValue.SearchTerm) {
					filterModel.SearchTerm = cookieValue.SearchTerm;
				}
				if (cookieValue.Tags) {
					filterModel.Tags = cookieValue.Tags;
				}
				if (cookieValue.Page) {
					filterModel.Page = parseInt(cookieValue.Page);
				}
				mediaCentreApp.setInputValue();
			}
			removeCookie();
		}
		

		//on submit
		$("#media-search-form").submit(function (e) {
			checkPageType(e);
			setCookie();
		});

		// save filterModel values in cookie to populate the selected options of the filter on Media Centre Article page
		function setCookie() {
			const date = new Date();
			const minutes = 1;
			date.setTime(date.getTime() + (minutes * 60 * 1000));
			$.cookie(cookieName, JSON.stringify(filterModel), { expires: date, path: '/' });
		}

		function removeCookie() {
			$.cookie(cookieName, null, { path: '/' });
		}

		function checkPageType(e) {
			// check if on media centre landing page
			if (pageType === mcLandingDocTypeAlias) {
				e.preventDefault();
				getFilterValues();
			}
			//else if on media centre article page, do nothing and allow form to submit back to media centre landing page
		}

		function getFilterValues() {
			filterModel.Month = parseInt($("#month").find(":selected").val());
			filterModel.Year = parseInt($("#year").find(":selected").val());
			filterModel.SearchTerm = $("#searchArg").val();
			filterModel.Tags = $("#tags").val().length > 0 ? $("#tags").val() : null;
			filterModel.Page = 1;
			mediaCentreApp.GetSearchResults();
		}


		//on pagination click event
		$(document).on('click', 'ul.pagination a', function (e) {
			e.preventDefault();
			filterModel.Page = $(this).data('page');
			setCookie();
			mediaCentreApp.GetSearchResults();
		});


		// copy searchMobile text to search field
		$("#searchMobile").on("keyup paste", function () {
			$("#search").val($(this).val());
		});
	});

})(mediaCentre);
